import { ReturnsAndClaimsPermissions } from "@redotech/account-common/permissions";
import * as z from "zod";
import { canApproveReturn } from "../../returns/return-action-eligibility";
import { defineReturnAction } from "../types";

/**
 * No per-item weights, address or labels: bulk approves each return as the
 * approve modal would with nothing touched.
 */
const BulkApprovePayloadSchema_ = z.object({ sendNotification: z.boolean() });
export interface ApprovePayload extends z.infer<
  typeof BulkApprovePayloadSchema_
> {}

export const approveReturnAction = defineReturnAction<ApprovePayload>({
  label: "Approve",
  permissions: [ReturnsAndClaimsPermissions.APPROVE_RETURN],
  isEligible: ({ return_, user }) => canApproveReturn({ return_, user }),
  payloadSchema: BulkApprovePayloadSchema_,
  examplePayload: { sendNotification: true },
});
